import { qx_eDeviceKind_enum } from '@/graphql/types';

export interface DoorDeviceKindSource {
  device?: { kind?: qx_eDeviceKind_enum | null } | null;
}

export function isOfflineLockDoor(door?: DoorDeviceKindSource | null): boolean {
  return door?.device?.kind === qx_eDeviceKind_enum.OfflineLock;
}

// Filters on the door's own `deviceKind`, not `device.kind`: a filter through the device
// relationship matches no door for users who cannot read devices.
export const EXCLUDE_OFFLINE_LOCK_DOORS = {
  deviceKind: { _neq: qx_eDeviceKind_enum.OfflineLock }
};
